import React, { useEffect } from 'react'
import './Inspecciones.css'
import Magnet from '../Magnet/Magnet'
import LazyVideo from '../LazyVideo/LazyVideo'
import { useLocation } from "react-router-dom";


function Inspecciones() {

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth' });
                }, 50);
            }
        }
    }, [location]);

    useEffect(() => {
        const els = document.querySelectorAll('.serv-card.reveal');
        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    io.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
        els.forEach(el => io.observe(el));
        return () => io.disconnect();
    }, []);

    const items = [
        {
            num: '01',
            title: 'TORRES DE COMUNICACIÓN Y ALTA TENSIÓN',
            desc: 'Se evalúa el estado estructural de antenas, mástiles y sistemas de transmisión sin necesidad de que los técnicos accedan físicamente a la torre. Se capturan imágenes detalladas de todos los elementos críticos, facilitando la detección temprana de anomalías. Este método reduce significativamente los riesgos asociados a trabajos en altura y minimiza el tiempo de intervención en la infraestructura.',
            media: { type: 'video', src: '/media/torres.mp4' }
        },
        {
            num: '02',
            title: 'PLANTAS FOTOVOLTAICAS',
            desc: 'Inspecciones con cámara térmica para detectar anomalías en las placas fotovoltaicas que afecten al rendimiento energético de la planta de forma rápida y precisa; células dañadas, diodos o conexiones defectuosas, strings o módulos desconectados, etc. Análisis e informes de acuerdo a la normativa IEC TS 62446-3.',
            media: { type: 'video', src: '/media/termico.mp4' }
        },
        {
            num: '03',
            title: 'AEROGENERADORES',
            desc: 'Inspección tanto visual como térmica que permita evaluar el estado estructural de las turbinas eólicas de forma rápida, segura y con gran nivel de detalle. Mediante sensores ópticos de alta resolución, se capturan imágenes y vídeo para detectar anomalías en palas, torre y góndola sin necesidad de detener la instalación durante largos períodos, reduciendo significativamente el coste de personal y tiempo además de acotar el riesgo laboral.',
            media: { type: 'video', src: '/media/aerogeneradores.mp4' }
        },
        {
            num: '04',
            title: 'TECHOS Y PUENTES',
            desc: 'Las inspecciones en este tipo de infraestructuras permiten analizar su estado sin necesidad de instalar andamios, plataformas elevadoras o cortar el tráfico en el caso de infraestructuras viarias. El dron captura imágenes de alta resolución de zonas de difícil acceso, lo que facilita la detección de daños estructurales, filtraciones o deterioro de materiales de forma rápida y segura.',
            media: { type: 'image', src: '/media/puentes.webp', alt: 'puentes' }
        }
    ];

    return (
        <div className='degradado'>
            <div className="safety-stack">
                {items.map((item, i) => (
                    <article
                        key={item.num}
                        className={`serv-card reveal feat-card${i % 2 ? ' feat-card--rev' : ''}`}
                    >
                        <div className="serv-card__media">
                            {item.media.type === 'video' ? (
                                <LazyVideo src={item.media.src} className='serv-card__video' />
                            ) : (
                                <img src={item.media.src} alt={item.media.alt} loading="lazy" className='serv-card__img' />
                            )}
                        </div>
                        <div className="serv-card__body">
                            <span className="serv-card__num">{item.num} / 04</span>
                            <h3 className="serv-card__title">{item.title}</h3>
                            <p className="serv-card__desc">{item.desc}</p>
                        </div>
                    </article>
                ))}
            </div>

            <div className="espacio">
                <Magnet padding={30} disabled={false} magnetStrength={2} wrapperClassName='magneto' innerClassName='magnetoDos'>
                    <button onClick={() => window.location.href = "/#contacto"} className='cta'>
                        <span>CONTÁCTANOS</span>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </button>
                </Magnet>
            </div>
        </div>
    )
}

export default Inspecciones
